"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedArrTypes = [
    'Int8Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Int16Array',
    'Uint16Array',
    'Int32Array',
    'Uint32Array',
    'Float32Array',
    'Float64Array',
];
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@replit/alcor/dist/types.js
// module id = 29
// module chunks = 0